export const gridPipelessReducer: GridReducerType = (
    state: GridReducerState = getInitialState(),
    item: GridReducerItem
) => {
    let newState: GridReducerState = []
    switch (item?.type) {
        case 'start':
            if (!item.events || item.events.info?.isNormalizerConfig || item.events.info?.isEmptyQuery) return state

            newState = (state ?? []).map(layerEvents =>
                layerEvents?.map((e, idx) => ({ ...(e ?? {}), ...(idx ? {} : { info: { ...(e?.info ?? {}) } }) }))
            )

            newState[item.layer] = [{ ...item.events, info: { ...(item.events.info ?? {}) } }]

            return newState
        case 'event':
            if (!item.events || !item.events[0]) return state

            if (item.events[0].curves) {
                try {
                    const curves = JSON.parse(item.events[0].curves)

                    return (state ?? []).map(layerEvents =>
                        layerEvents?.map((e, idx) => ({
                            ...(e ?? {}),
                            ...(idx ? {} : { info: { ...(e?.info ?? {}), curves } })
                        }))
                    )
                } catch (e) {
                    // JSON syntax error
                    return state ?? []
                }
            }

            newState = (state ?? []).map(layerEvents =>
                layerEvents?.map((e, idx) => ({ ...(e ?? {}), ...(idx ? {} : { info: { ...(e?.info ?? {}) } }) }))
            )
            newState[item.layer] = [
                ...(newState[item.layer]?.filter(e => e.mnemonic !== item.events[0].mnemonic) ?? []),
                item.events[0]
            ]

            return newState
        default:
            return state
    }
}

export const gridReducer: GridReducerType = (state: GridReducerState = getInitialState(), item: GridReducerItem) => {
    let newState: GridReducerState = []
    switch (item?.type) {
        case 'start':
            if (!item.events) return state

            newState = (state ?? []).map(layerEvents =>
                layerEvents?.map((e, idx) => ({ ...(e ?? {}), ...(idx ? {} : { info: { ...(e?.info ?? {}) } }) }))
            )

            newState[item.layer] = [{ ...item.events, info: { ...(item.events.info ?? {}) } }]

            return newState
        case 'event':
            if (!item.events) return state

            newState = (state ?? []).map(layerEvents =>
                layerEvents?.map((e, idx) => ({ ...(e ?? {}), ...(idx ? {} : { info: { ...(e?.info ?? {}) } }) }))
            )
            newState[item.layer] = [
                ...(newState[item.layer] ?? []).slice(0, 1),
                ...item.events.map(e => ({ ...(e ?? {}) }))
            ]

            return newState
        default:
            return state
    }
}

const getInitialState = (): GridReducerState => []
